import { useContext } from "react";
import TabContext from "../store/tab-context";
import css from "./Slide.module.css";

function Slide(props) {
  const tabContext = useContext(TabContext);

  const slidePositionLeft =
    props.slidePosition === "left"
      ? tabContext.value === tabContext.values.both
        ? css.slideFromLeftToMiddle
        : tabContext.value === tabContext.values.export
        ? css.slideFromLeftToLeft
        : css.slideFromLeftToRight
      : null;

  const slidePositionRight =
    props.slidePosition === "right"
      ? tabContext.value === tabContext.values.both
        ? css.slideFromRightToMiddle
        : tabContext.value === tabContext.values.import
        ? css.slideFromRightToRight
        : css.slideFromRightToLeft
      : null;

  return (
    <div
      className={`
            ${
              tabContext.value === tabContext.values.both
                ? css.slideHalfWidth
                : css.slide
            }
            ${slidePositionLeft}
            ${slidePositionRight}
            `}
    >
      {props.children}
    </div>
  );
}

export default Slide;
